import { render, staticRenderFns } from "./CmgPasswordReset.vue?vue&type=template&id=55d83e3f&scoped=true&lang=pug"
import script from "./cmg-password-reset.ts?vue&type=script&lang=ts&external"
export * from "./cmg-password-reset.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d83e3f",
  null
  
)

export default component.exports